import React from 'react'
import HotServices from '../../../services/HotChartServices';
import PlanServices from '../../../services/PlanServices';
import NotificationServices from '../../../services/NotificationServices';
import ComanServices from '../../../services/ComanServices'
import ViewTradingServices from '../../../services/ViewTradingServices';
function DeleteButton({data,page,closeModal,onSuccess}) {


  const handleDelete = async () => {
  if(page === 'plan'){
    const res = await PlanServices.deletePlan(data._id);
    
    if(res.status === true){
      alert('deleted successfully');
      
      onSuccess();

      closeModal();
    } 
    else {
      console.log(res)
    }
  
  }else if(page === 'subscription'){
    const res = await PlanServices.deleteSubscription(data._id);
    
    if(res.status === true){
      alert('deleted successfully');
      
      onSuccess();

      closeModal();
    } 
    else {
      console.log(res)
    }
  
  }else if(page === 'hotchart'){
    const res = await HotServices.deleteHotChart(data._id);
    
    if(res.status === true){
      alert('deleted successfully');
      
      onSuccess();

      closeModal();
    } 
    else {
      console.log(res)
    }
  
  }else if(page === 'web'){
    const res = await ViewTradingServices.deleteWebhook(data._id);
    
    if(res.status === true){
      alert('deleted successfully');
      
      onSuccess();

      closeModal();
    } 
    else {
      console.log(res)
    }
  
  }
  else if(page === 'blog'){
    const res = await ComanServices.bl(data._id);
    
    if(res.status === true){
      alert('deleted successfully');
     
      onSuccess();

      closeModal();
    } 
    else {
      console.log(res)
    }
  
  }else if(page === 'stock'){
    const res = await ComanServices.deleteStock(data._id);
    
    if(res.status === true){
      alert('deleted successfully');
    
      onSuccess();
      closeModal();
    } 
    else {
      console.log(res)
    }
  
  }
  }


  return (
    <div className="modal fade show d-block" id="deleteACModel" tabIndex="-1" aria-labelledby="deleteACModelLabel" aria-hidden="true">
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content modal-bg-light-green">
          <div className="modal-body py-4 px-5 text-center">
              <h4>Warning !!</h4>
              <p className="desc my-2">Are you sure you want to delete This Detail ?</p>
              <div className="donate-btn-grp text-center py-4">
                  <button className="site-btn btn-blue delete-btn" onClick={closeModal}>Cancel</button>
                  <button className="site-btn btn-red delete-btn" onClick={handleDelete}>Delete </button>
              </div>
          </div>
      </div>
    </div>
  </div>
  )
}

export default DeleteButton